import React from "react";
import { clsx } from "clsx";

interface IPostContentProps extends React.PropsWithChildren {
  post: Queries.MicrocmsPost;
}

export default function PostContent(props: IPostContentProps) {
  const { post } = props;

  return (
    <article
      className={clsx("lg:max-w-3xl", "md:max-w-2xl", "px-3", "w-full")}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
      dangerouslySetInnerHTML={{ __html: post.content ?? "" }}
    />
  );
}
